import { useQuery } from 'hooks/useCustomQuery';
import { axios } from '@/services/axios';

/**
 * A company's defined attributes.
 *
 * Previously dispatched `{ ...currentCompanyData, definedAttributes }` into
 * `navigationLists.currentCompanyData`. Callers pass their own object — the
 * company edit form passes live, unsaved form state — so that dispatch
 * published form values into the globally shared current-company record.
 * Consumers now read the returned data instead.
 *
 * @param {{ id?: string }} company
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
const useGetCompanyDefinedAttributes = (company) => {
    const companyID = company?.id;

    return useQuery({
        queryKey: ['companyDefinedAttributes', companyID],
        queryFn: async () => {
            const res = await axios.get(
                `company/${companyID}/definedattributes`,
            );
            return res.data;
        },
        enabled: Boolean(companyID),
        staleTime: 0,
    });
};

export default useGetCompanyDefinedAttributes;
